import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ExpertiseSection from './components/ExpertiseSection';
import ServicesSection from './components/ServicesSection';
import DifferentiatorSection from './components/DifferentiatorSection';
import TeamSection from './components/TeamSection';
import ContactSection from './components/ContactSection';
import SeoJsonLd from '../../components/feature/SeoJsonLd';

export default function Home() {
  return (
    <div className="min-h-screen bg-stone-100">
      <SeoJsonLd />
      <Header />
      <main>
        <HeroSection />
        <ExpertiseSection />
        <ServicesSection />
        <DifferentiatorSection />
        <TeamSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
